export const GlobalVariable = Object.freeze({
    //BASE_API_URL: 'http://localhost:56834' //Dev API
    BASE_API_URL:'https://datalink.pharmacylink.com/LibertyAPI' //Prod API
});



// WEBPACK FOOTER //
// ./src/app/common/global.ts